import Service, { type Registry as Services, service } from '@ember/service';
import type AjaxService from 'lumen/services/ajax';

export default class PmRequestServiceService extends Service {
  @service declare ajax: AjaxService;
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];

  handleRequestError(error: unknown): void {
    this.errorTracking.captureException(error);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.alerting.showErrorAlert();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  requestData(url: string) {
    return this.ajax
      .request(url, {
        method: 'GET',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
      })
      .catch((error) => {
        this.handleRequestError(error);
      });
  }
}

declare module '@ember/service' {
  interface Registry {
    'pm-request-service': PmRequestServiceService;
  }
}
